import { SignPdfService } from '../sign-pdf.service';
import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  @Input() id: string='';
  private element: any;

  constructor( private signPdfService: SignPdfService, private el: ElementRef) {
      this.element = el.nativeElement;
      this.close();
  }

  ngOnInit(): void {
      if (!this.id) {
          console.error('modal must have an id');
          return;
      }

      document.body.appendChild(this.element);
      this.element.addEventListener('click', (el:any) => {
          if (el.target.className === 'u-modal') {
              this.close();
          }
      });
      this.signPdfService.add(this);
  }
  ngOnDestroy(): void {
      this.signPdfService.remove(this.id);
      this.element.remove();
  }

  open(): void {
      this.element.style.display = 'block';
      document.body.classList.add('u-modal-open');
  }

  close(): void {
      this.element.style.display = 'none';
      document.body.classList.remove('u-modal-open');
  }

}
